import { render, staticRenderFns } from "./About.vue?vue&type=template&id=b080d5ba&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=b080d5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080d5ba",
  null
  
)

export default component.exports